import { isEmpty } from "lodash"
import React, { useEffect, useState } from "react"
import Chart from "react-apexcharts"
import { useSelector, useDispatch } from "react-redux"

const AttendeesByAge = () => {
  const { attendeebyage } = useSelector(state => state.Dashboard)
  const [labels, setLabels] = useState([])
  const [seriesData, setDataSeries] = useState([])

  useEffect(() => {
    if (!isEmpty(attendeebyage)) {
      setLabels(attendeebyage[0].Labels.split(","))
      setDataSeries(attendeebyage[0].Series?.split(",").map(Number))
    }
  }, [attendeebyage])

  const options = {
    chart: {
      type: "bar",
      height: 300,
      toolbar: {
        show: false, // Removes the menu icon
      },
    },
    plotOptions: {
      bar: {
        horizontal: true,
      },
    },
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      categories: labels,
    },
    colors: ["#008FFB"],
  }

  const series = [
    {
      name: "Count",
      data: seriesData,
    },
  ]

  return <Chart options={options} series={series} type="bar" height={300} />
}

export default AttendeesByAge
